module.exports = __webpack_public_path__ + "img/welcome.ebdd5bc0.png";